// assets/h2m-mobile-accordion.js
(function () {
  "use strict";

  var MOBILE_MAX_WIDTH = 989;
  var ROOT_SELECTOR = ".h2m-menu__mobile";

  var MAIN_ITEM_SELECTOR = ".h2m-main-menu-item.h2m-mega_menu";
  var MEGA_WRAPPER_SELECTOR = ".h2m-mega-wrapper.h2m-submenu--root";

  var BLOCK_TITLE_SELECTOR = "a.h2m-block--title";
  var SUBMENU_SELECTOR = "ul.h2m-submenu-content";

  var ACC_BTN_CLASS = "h2m-acc-btn";
  var OPEN_CLASS = "h2m-acc-open";

  // Product tabs selectors
  var TABS_ROOT_SELECTOR = ".pxu-tabs";
  var TAB_LABEL_SELECTOR = ".tab-label";
  var TAB_PANEL_SELECTOR = ".tab-panel";
  var TAB_ACC_BTN_CLASS = "pxu-acc-btn";
  var TAB_OPEN_CLASS = "pxu-acc-open";
  var TAB_ALLOW_MULTI_OPEN = false;

  function isMobile() {
    return window.matchMedia("(max-width:" + MOBILE_MAX_WIDTH + "px)").matches;
  }

  function ensureStyles() {
    if (document.getElementById("h2m-acc-styles")) return;

    var style = document.createElement("style");
    style.id = "h2m-acc-styles";
    style.textContent =
      ROOT_SELECTOR + " " + BLOCK_TITLE_SELECTOR + "{display:flex;align-items:center;justify-content:space-between;}" +
      ROOT_SELECTOR + " ." + ACC_BTN_CLASS + "{margin-left:10px;width:38px;height:38px;display:inline-flex;align-items:center;justify-content:center;background:transparent;border:0;padding:0;cursor:pointer;-webkit-tap-highlight-color:transparent;}" +
      ROOT_SELECTOR + " ." + ACC_BTN_CLASS + " svg{width:18px;height:18px;transform:rotate(0deg);transition:transform 160ms ease;}" +
      ROOT_SELECTOR + " ." + OPEN_CLASS + " ." + ACC_BTN_CLASS + " svg{transform:rotate(180deg);}" +
      ROOT_SELECTOR + " .h2m-mega-wrapper{display:flex !important;padding:0 10px !important;}" +

      // Product tabs accordion styles
      TABS_ROOT_SELECTOR + " " + TAB_LABEL_SELECTOR + "{display:flex;align-items:center;justify-content:space-between;cursor:pointer;}" +
      TABS_ROOT_SELECTOR + " ." + TAB_ACC_BTN_CLASS + "{margin-left:10px;width:38px;height:38px;display:inline-flex;align-items:center;justify-content:center;background:transparent;border:0;padding:0;cursor:pointer;-webkit-tap-highlight-color:transparent;}" +
      TABS_ROOT_SELECTOR + " ." + TAB_ACC_BTN_CLASS + " svg{width:18px;height:18px;transform:rotate(0deg);transition:transform 160ms ease;}" +
      TABS_ROOT_SELECTOR + " ." + TAB_OPEN_CLASS + " ." + TAB_ACC_BTN_CLASS + " svg{transform:rotate(180deg);}";

    document.head.appendChild(style);
  }

  function chevronSvg() {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M6.7 9.3a1 1 0 0 1 1.4 0L12 13.2l3.9-3.9a1 1 0 1 1 1.4 1.4l-4.6 4.6a1 1 0 0 1-1.4 0L6.7 10.7a1 1 0 0 1 0-1.4z"></path>' +
      "</svg>"
    );
  }

  function showEl(el) {
    if (!el) return;
    el.hidden = false;
    el.style.display = "";
  }

  function hideEl(el) {
    if (!el) return;
    el.hidden = true;
    el.style.display = "none";
  }

  function setExpanded(el, expanded) {
    if (!el) return;
    el.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  function openMainMegaMenus(root) {
    root.querySelectorAll(MAIN_ITEM_SELECTOR).forEach(function (item) {
      var mega = item.querySelector(MEGA_WRAPPER_SELECTOR);
      if (mega) showEl(mega);

      var link = item.querySelector("a.h2m-menu-item-inner");
      if (link) setExpanded(link, true);
    });
  }

  function enhanceBlocks(root) {
    root.querySelectorAll(BLOCK_TITLE_SELECTOR).forEach(function (titleLink) {
      var block = titleLink.closest(".h2m-megamenu__block-item") || titleLink.parentElement;
      if (!block) return;

      var submenu = block.querySelector(SUBMENU_SELECTOR);
      if (!submenu) return;

      if (titleLink.querySelector("." + ACC_BTN_CLASS)) return;

      block.classList.remove(OPEN_CLASS);
      hideEl(submenu);

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = ACC_BTN_CLASS;
      btn.setAttribute("aria-label", "Submenu openen of sluiten");
      setExpanded(btn, false);
      btn.innerHTML = chevronSvg();

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = block.classList.contains(OPEN_CLASS);
        if (isOpen) {
          block.classList.remove(OPEN_CLASS);
          hideEl(submenu);
          setExpanded(btn, false);
        } else {
          block.classList.add(OPEN_CLASS);
          showEl(submenu);
          setExpanded(btn, true);
        }
      });

      titleLink.appendChild(btn);
    });
  }

  // Mobile accordion behavior for pxu tabs
  function enhanceProductTabs() {
    if (!isMobile()) return;

    document.querySelectorAll(TABS_ROOT_SELECTOR).forEach(function (tabsRoot) {
      var labels = tabsRoot.querySelectorAll(TAB_LABEL_SELECTOR);
      if (!labels.length) return;

      labels.forEach(function (label) {
        if (label.querySelector("." + TAB_ACC_BTN_CLASS)) return;

        var inputId = label.getAttribute("for");
        if (!inputId) return;

        var input = document.getElementById(inputId);
        if (!input) return;

        var panel = label.nextElementSibling;
        if (!panel || !panel.classList.contains("tab-panel")) return;

        // Init state based on checked
        if (input.checked) {
          label.classList.add(TAB_OPEN_CLASS);
          showEl(panel);
        } else {
          label.classList.remove(TAB_OPEN_CLASS);
          hideEl(panel);
        }

        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = TAB_ACC_BTN_CLASS;
        btn.setAttribute("aria-label", "Tab openen of sluiten");
        btn.innerHTML = chevronSvg();
        setExpanded(btn, input.checked);

        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleTab(tabsRoot, label, input, panel, btn);
        });

        label.addEventListener("click", function (e) {
          // Alleen mobiel gedrag, voorkom standaard radio switch
          e.preventDefault();
          toggleTab(tabsRoot, label, input, panel, btn);
        });

        label.appendChild(btn);
      });
    });
  }

  function scrollLabelIntoView(label) {
  if (!label) return;

  var rect = label.getBoundingClientRect();
  var absoluteTop = rect.top + window.pageYOffset;

  // Houd rekening met sticky header als die er is
  var header = document.querySelector(".site-header, .header, .sticky-header, [data-header]");
  var offset = 12;

  if (header) {
    var h = header.getBoundingClientRect().height;
    if (h && h > 0 && h < 200) offset += h;
  }

  window.scrollTo({
    top: Math.max(absoluteTop - offset, 0),
    behavior: "smooth"
  });
}

  function toggleTab(tabsRoot, label, input, panel, btn) {
  var wasOpen = label.classList.contains(TAB_OPEN_CLASS);

  if (wasOpen) {
    label.classList.remove(TAB_OPEN_CLASS);
    hideEl(panel);
    input.checked = false;
    setExpanded(btn, false);
    return;
  }

  if (!TAB_ALLOW_MULTI_OPEN) {
    var openLabels = tabsRoot.querySelectorAll(TAB_LABEL_SELECTOR + "." + TAB_OPEN_CLASS);
    openLabels.forEach(function (otherLabel) {
      var otherFor = otherLabel.getAttribute("for");
      if (!otherFor) return;

      var otherInput = document.getElementById(otherFor);
      var otherPanel = otherLabel.nextElementSibling;
      var otherBtn = otherLabel.querySelector("." + TAB_ACC_BTN_CLASS);

      otherLabel.classList.remove(TAB_OPEN_CLASS);
      if (otherPanel && otherPanel.classList.contains("tab-panel")) hideEl(otherPanel);
      if (otherInput) otherInput.checked = false;
      if (otherBtn) setExpanded(otherBtn, false);
    });
  }

  label.classList.add(TAB_OPEN_CLASS);
  showEl(panel);
  input.checked = true;
  setExpanded(btn, true);

  // scroll nadat DOM is aangepast
  window.requestAnimationFrame(function () {
    scrollLabelIntoView(label);
  });
}

  function runVanilla() {
    if (!isMobile()) return;

    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    ensureStyles();
    openMainMegaMenus(root);
    enhanceBlocks(root);
    enhanceProductTabs();
  }

  function runJquery($) {
    if (!isMobile()) return;

    var $root = $(ROOT_SELECTOR);
    if (!$root.length) return;

    ensureStyles();

    $root.find(MAIN_ITEM_SELECTOR).each(function () {
      var $mega = $(this).find(MEGA_WRAPPER_SELECTOR).first();
      if ($mega.length) $mega.prop("hidden", false).css("display", "flex");
    });

    $root.find(BLOCK_TITLE_SELECTOR).each(function () {
      var $title = $(this);
      var $block = $title.closest(".h2m-megamenu__block-item");
      if (!$block.length) $block = $title.parent();

      var $submenu = $block.find(SUBMENU_SELECTOR).first();
      if (!$submenu.length) return;

      if ($title.find("." + ACC_BTN_CLASS).length) return;

      $block.removeClass(OPEN_CLASS);
      $submenu.prop("hidden", true).css("display", "none");

      var $btn = $("<button/>", {
        type: "button",
        "class": ACC_BTN_CLASS,
        "aria-label": "Submenu openen of sluiten",
        "aria-expanded": "false",
        html: chevronSvg()
      });

      $btn.on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = $block.hasClass(OPEN_CLASS);
        if (isOpen) {
          $block.removeClass(OPEN_CLASS);
          $submenu.prop("hidden", true).css("display", "none");
          $btn.attr("aria-expanded", "false");
        } else {
          $block.addClass(OPEN_CLASS);
          $submenu.prop("hidden", false).css("display", "");
          $btn.attr("aria-expanded", "true");
        }
      });

      $title.append($btn);
    });

    // Tabs in jQuery branch, maar zonder jQuery afhankelijkheid
    enhanceProductTabs();
  }

  function init() {
    var jq = window.jQuery;
    if (typeof jq === "function") runJquery(jq);
    else runVanilla();
  }

  document.addEventListener("DOMContentLoaded", function () {
    init();

    var obs = new MutationObserver(function () {
      init();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener("resize", function () {
      init();
    });
  });
})();